document.addEventListener('DOMContentLoaded', function () {
  if (!window.trialChildInfoEnabled) return;
  const confirmedForms = new WeakSet();

  // Capture phase on document = fires BEFORE the theme's own ProductForm
  // submit handler, regardless of when that handler was attached.
  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
      if (confirmedForms.has(form)) return; // already collected, let it through

      e.preventDefault();
      e.stopImmediatePropagation();
      openTrialModal(form);
    },
    true
  );

  function openTrialModal(form) {
    const template = document.getElementById('trial-child-info-template');
    if (!template || typeof tingle === 'undefined') {
      // Fallback: if tingle isn't loaded for some reason, don't block checkout.
      confirmedForms.add(form);
      form.requestSubmit();
      return;
    }

    const modal = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['trial-child-info-modal'],
    });
    modal.setContent(template.innerHTML);
    modal.open();

    const box = document.querySelector('.tingle-modal');

    function proceed() {
      // Either field may be absent — hidden via Theme Settings.
      const nameInput = box.querySelector('[name="child_name_temp"]');
      const dobInput = box.querySelector('[name="child_dob_temp"]');
      if (nameInput) setProperty(form, 'Child Name', nameInput.value);
      if (dobInput && dobInput.value) setProperty(form, 'Child DOB', formatDob(dobInput.value));
      confirmedForms.add(form);
      modal.close();
      form.requestSubmit();
    }

    box.querySelector('[data-trial-continue]').addEventListener('click', proceed);
    box.querySelector('[data-trial-skip]').addEventListener('click', function () {
      confirmedForms.add(form);
      modal.close();
      form.requestSubmit();
    });
  }

  // <input type="date"> always returns its .value in ISO format (yyyy-mm-dd),
  // regardless of the dd-mm-yyyy display the browser shows the shopper.
  // Convert to dd-mm-yyyy here so it's consistent everywhere downstream
  // (cart, order properties, admin, notification emails).
  function formatDob(isoValue) {
    const parts = isoValue.split('-'); // [yyyy, mm, dd]
    if (parts.length !== 3) return isoValue; // fallback, don't break on bad input
    const [yyyy, mm, dd] = parts;
    return dd + '-' + mm + '-' + yyyy;
  }

  function setProperty(form, name, value) {
    let input = form.querySelector('input[name="properties[' + name + ']"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      form.appendChild(input);
    }
    input.value = value;
  }
});